export const DEFAULT_LAYOUT = 'xing-unified';
